import axios from "axios";

// 401 = unauthenticated (missing/invalid token). Clear any persisted session and send the
// user to the login screen. This only ever runs inside async catch handlers, never during
// render, so a full-page navigation here is safe. A full reload also resets the in-memory
// Redux store, so no token survives.
// One-shot: if many requests 401 at once, only the first triggers the redirect — otherwise
// the burst would fire repeated navigations (a request/redirect storm).
let hasRedirectedToLogin = false;

const redirectToLogin = () => {
  if (hasRedirectedToLogin) return;
  hasRedirectedToLogin = true;

  try {
    localStorage.removeItem("state");
  } catch (err) {
    // ignore storage errors
  }

  if (
    typeof window !== "undefined" &&
    !window.location.pathname.includes("/login")
  ) {
    window.location.assign("/login");
  }
};

export const errorHandeling = (error) => {
  if (axios.isAxiosError(error)) {
    // Network error (no response at all)
    if (error.code === "ERR_NETWORK") {
      return "*تعذر الاتصال بالخادم، يرجى التحقق من اتصالك بالإنترنت";
    }

    if (error.response) {
      const statusCode = error.response.status;
      const serverMessage = error.response.data?.message;

      // 401 -> not logged in: clear session and redirect to login
      if (statusCode === 401) {
        redirectToLogin();
        return "انتهت الجلسة، يرجى تسجيل الدخول من جديد";
      }

      // 403 -> logged in but not allowed (permission / policy denial)
      if (statusCode === 403) {
        return serverMessage || "ليس لديك صلاحية للقيام بهذا الإجراء";
      }

      // 404 -> missing resource, or a resource outside your visibility scope
      if (statusCode === 404) {
        return serverMessage || "العنصر المطلوب غير موجود أو خارج نطاق صلاحيتك";
      }

      // 422 -> validation errors
      if (statusCode === 422) {
        const errors = error.response.data?.errors;
        if (errors && typeof errors === "object") {
          // Flatten all field messages into one string
          const errorMessages = Object.values(errors).flat().join("، ");
          return `*${errorMessages}`;
        }
        return serverMessage ? `*${serverMessage}` : "*خطأ في البيانات المرسلة";
      }

      // 500+ server errors
      if (statusCode >= 500) {
        return "هناك خطأ في الخادم";
      }

      // Any other status: prefer the server-provided message from the envelope
      if (serverMessage) {
        return `*${serverMessage}`;
      }
    }
  }

  console.error("Unexpected error: ", error);
  return "*خطأ غير متوقع يرجى المحاولة لاحقا";
};
